<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 10:44:04
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-09-03 11:39:44
 * @Description: 角色管理 V2 版本
 -->
<template>
  <obitUniversalTable name="角色列表" :pagination="pagination" v-if="$fmt(['sys_normal_disable','sys_data_scope'])">
    <template #search>
      <obit-search-form :params="params" :paramList="paramList" @search="pageQuery(true)">
      </obit-search-form>
    </template>
    <template #btn>
      <a-button type="primary" @click="addDialog">
        <i class="iconfont icon-add-bold p-r-5"></i> 新 增
      </a-button>
    </template>
    <a-table :loading="pageLoading" rowKey="roleId" :columns="tableColumns"
      :scroll="{ x: '100%' }" :dataSource="pageDataList" :pagination="false" class="obit-atable" highlight-current-row
      style="width: 100%">
      <template #sort="{record,index}">
        {{(pageParams.pageNum-1)*10+index+1}}
      </template>
      <template #status="{record}" :key="record.roleId">
        <obitSwitchUrl v-model:value="record.status" check="正常" uncheck="停用" activeValue="0" inactiveValue="1"
          :info="{ ajaxUrl:'system/role/editState', fieldName: 'status',ajaxType: 'post',data:{roleId:record.roleId} }" @reload="pageQuery(true)">
        </obitSwitchUrl>
      </template>
      <template #operation="{ record  }" :key="record.roleId">
        <div v-if="record.roleId!=='1'">
          <a-button class="operation-btn" type="link" @click="editDialog(record)">编辑</a-button>
          <a-button class="operation-btn" type="link" @click="remove(record)">删除</a-button>
          <a-button class="operation-btn" type="link" @click="editScopeDialog(record)">数据权限 </a-button>
        </div>
      </template>
    </a-table>
  </obitUniversalTable>
  <roleAdd :addType="addType" :detailsInfo="detailsInfo" v-model:open="addVisable" v-if="addVisable"  @reload="pageQuery(true)">
  </roleAdd>
  <roleScopeAdd :detailsInfo="detailsInfo" v-model:open="scopeVisable" v-if="scopeVisable" :type="scopeType" @reload="pageQuery(true)">
  </roleScopeAdd>
</template>

<script>
import { onMounted, getCurrentInstance, inject, reactive, toRefs } from 'vue'
import roleAdd from './roleAdd.vue'
import page from 'obit-wui/hook/page'
import roleScopeAdd from './roleScopeAdd.vue'
import obitSwitchUrl from '../../../components/obitSwitchUrl.vue'

export default {
  components: { roleAdd, roleScopeAdd,obitSwitchUrl },
  setup (props, context) {
    let http = inject('http')
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      tableColumns: [
        { slots: { customRender: 'sort' }, title: '序号', width: 60 },
        { dataIndex: 'roleName', title: '角色名称', width: 200 },
        { dataIndex: 'createTime', title: '创建时间', width: 180 },
        { slots: { customRender: 'status' }, title: '状态', width: 100 },
        { title: '操作', slots: { customRender: 'operation' }, width: 300 },
      ],
      paramList: [
        { name: '角色名称', key: 'roleName' },
        { name: "角色状态", key: "status", type: "dict", dictCode: "sys_normal_disable" },
      ],
      loading: false,
      roleList: [],
      checkRole: '',
      // 新增编辑相关
      addVisable: false,
      scopeVisable: false,
      userVisable: false,
      scopeType: 'scope',
      addType: 'add',
      roleId: '',
      detailsInfo: {},
      appId: '',
    })
    let pageIns = page({
      url: 'system/role/pageList',
      key: 'roleId',
      removeUrl: 'system/role/remove',
    })
    let _methods = {
      // 角色新增和编辑相关  --------------start --------------------------
      addDialog () {
        _data.addVisable = true
        _data.addType = 'add'
        _data.detailsInfo = {}
      },
      editDialog (item) {
        _data.detailsInfo = item
        _data.addVisable = true
        _data.addType = 'edit'
      },
      editScopeDialog (item) {
        _data.detailsInfo = item
        _data.scopeVisable = true
      },
      // editUserDialog (item) {
      //   router.push({ path: 'role/bindUser', query: { roleId: item.roleId, name: item.roleName } })
      // },
    }
    onMounted(() => {
      pageIns._method.pageQuery()
    })
    return {
      ...toRefs(pageIns._data),
      ...pageIns._method,
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>

<style lang='less' >
</style>